import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=44571508&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=44571508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44571508",
  null
  
)

export default component.exports